import React from "react";
import T from "prop-types";
import { Map } from "immutable";
import { get } from "lodash";
import { withRma } from "MODULES/RMAsAndWarranties/decorators";
import pojo from "LIB/pojos";
import { properCase } from "LIB/formatters/text";
import Section from "MODULES/shared/components/Section";
import { ShippingAddressTable } from "MODULES/shared/components/ShippingAddressTable";
import { Detail, DetailTable } from "MODULES/shared/components";
import {
  ACCOUNT_NUMBER,
  CARRIER,
  NAME,
  RETURN_TO_COMPANY_ADDRESS_ID,
  RETURN_TO_COMPANY_ID,
  RETURN_TO_CUSTOMER_ADDRESS_ID,
  RETURN_TO_FOB,
  RETURN_TO_LOCATION_ID,
  RETURN_TO_SHIPPING_ADDRESS,
  RETURN_TO_SHIPPING_METHOD,
  RETURN_TO_TYPE,
  SHIPPING_METHOD
} from "APP_ROOT/constants";
import { COMPANY } from "MODULES/companies/constants";
import { DROPSHIP } from "MODULES/PurchaseOrders/constants";
import { CARRIERS } from "MODULES/shared/constants";
import Form from "./Form";

function ReturnTo({ rma }) {
  const initialValues = pojo(rma.toJS()).pick(
    RETURN_TO_TYPE,
    RETURN_TO_COMPANY_ID,
    RETURN_TO_COMPANY_ADDRESS_ID,
    RETURN_TO_CUSTOMER_ADDRESS_ID,
    RETURN_TO_LOCATION_ID,
    RETURN_TO_SHIPPING_ADDRESS,
    RETURN_TO_SHIPPING_METHOD
  );
  const renderForm = close => (
    <Form close={close} rma={rma.toJS()} initialValues={initialValues} />
  );

  const dropShip = type => [COMPANY, DROPSHIP].includes(type);

  // Extract carrier and shipping method from RMA
  const carrier = rma.getIn(["return_to_shipping_method", CARRIER], "");
  const shippingMethod = rma.getIn(
    ["return_to_shipping_method", SHIPPING_METHOD],
    ""
  );
  const accountNumber = rma.getIn(
    ["return_to_shipping_method", ACCOUNT_NUMBER],
    ""
  );

  // Lookup label in CARRIERS constant using Lodash get
  const shippingMethodLabel = get(
    CARRIERS,
    [carrier, "shippingMethods", shippingMethod, "label"],
    ""
  );

  return (
    <Section
      title="Return To"
      modal={{
        title: "Edit RMA - Return To",
        content: renderForm
      }}
    >
      {(dropShip(rma.get(RETURN_TO_TYPE)) && (
        <ShippingAddressTable
          fob={rma.get(RETURN_TO_FOB)}
          address={rma.get("return_to_address")}
          shippingMethod={rma.get(RETURN_TO_SHIPPING_METHOD)}
        />
      )) || (
        <DetailTable>
          <Detail
            label="Return To"
            value={`${rma.getIn(["return_to_address", NAME], "")}`}
          />
          <Detail
            label="Carrier"
            value={properCase(
              `${rma.getIn(["return_to_shipping_method", CARRIER], "")}`
            )}
          />
          <Detail label="Shipping Method" value={shippingMethodLabel} />
          <Detail label="Account #" value={accountNumber} />
        </DetailTable>
      )}
      <hr className="hr-xs hr-dashed" />
    </Section>
  );
}

ReturnTo.propTypes = {
  rma: T.instanceOf(Map).isRequired
};

export default withRma(ReturnTo);



// WEBPACK FOOTER //
// ./app/modules/RMAsAndWarranties/components/Detail/Panel/ReturnTo/ReturnTo.jsx